import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature11',
      playScale: 0.5,
      always: false,
    },
    page: {
      className: 'home-page feature11-page',
    },
    title: {
      className: 'feature11-title',
      children: [
        {
          name: 'title0',
          className: 'feature11-title-item',
          children: '交通优势',
        },
      ],
    },
    content: {
      className: 'feature11-content',
      children: [
        {
          name: 'item0',
          className: 'feature11-content-item',
          img: {
            className: 'feature11-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(6).png',
          },
          imgIcon: {
            className: 'feature11-content-item-imgIcon',
            children: 'https://imm.86links.com/assets/landing/images/%E5%BD%A2%E7%8A%B6%E7%BB%93%E5%90%88%402x.png',
          },
          title: {
            className: 'feature11-content-item-title',
            children: '航空',
          },
          content: {
            className: 'feature11-content-item-content',
            children: '区域距成都双流国际机场<strong>20公里</strong></br>天府国际机场<strong>30公里</strong>',
          },
        },
        {
          name: 'item1',
          className: 'feature11-content-item',
          img: {
            className: 'feature11-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(5).png',
          },
          imgIcon: {
            className: 'feature11-content-item-imgIcon',
            children: 'https://imm.86links.com/assets/landing/images/%E5%BD%A2%E7%8A%B6%402x.png',
          },
          title: {
            className: 'feature11-content-item-title',
            children: '内陆口岸',
          },
          content: {
            className: 'feature11-content-item-content',
            children: '四川省唯一公路口岸：<strong>成都公路口岸</strong></br>以及以其为始发点的成都西部陆海新通道',
          },
        },
        {
          name: 'item2',
          className: 'feature11-content-item',
          img: {
            className: 'feature11-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(4).png',
          },
          imgIcon: {
            className: 'feature11-content-item-imgIcon',
            children: 'https://imm.86links.com/assets/landing/images/%E5%BD%A2%E7%8A%B6%E7%BB%93%E5%90%88%402x(1).png',
          },
          title: {
            className: 'feature11-content-item-title',
            children: '公路',
          },
          content: {
            className: 'feature11-content-item-content',
            children: '成安渝、成南、成渝、五环路、东安大道等高速、快速路穿境而过，形成“<strong>八横五纵</strong>“内联外畅骨干路网',
          },
        },
        {
          name: 'item3',
          className: 'feature11-content-item',
          img: {
            className: 'feature11-content-item-img',
            children: 'https://imm.86links.com/assets/landing/images/%E7%94%BB%E6%9D%BF%402x(3).png',
          },
          imgIcon: {
            className: 'feature11-content-item-imgIcon',
            children: 'https://imm.86links.com/assets/landing/images/%E5%BD%A2%E7%8A%B6%E7%BB%93%E5%90%88%402x(2).png',
          },
          title: {
            className: 'feature11-content-item-title',
            children: '铁路',
          },
          content: {
            className: 'feature11-content-item-content',
            children: '成都拥有亚洲最大的铁路集装箱中心站，蓉欧班列形成“<strong>三线并行</strong>”的格局；正在打造国家高铁枢纽城市',
          },
        },
      ],
    },

  },
};
